<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <p>{{ organization.name }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Organization',
    props: ['organization']
  }
</script>
